import React, { useEffect, forwardRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { Form, Button, Box, Input } from '@kufox/mui';
import useTheme from '@kufox/mui/hooks/useTheme';
import { HumanCaptcha, PhoneAreaSelector } from '../../components';
import { PHONELOGINTABKEY, ACCOUNTLOGINTABKEY, ACCOUNT_KEY, NAMESPACE } from '../constants';
import {
  REGEXP,
  useFormValidateByLang,
  ga,
  kcsensorsManualTrack,
  getTrackingSource,
} from '../../common/tools';

import { useLang } from '../../hookTool';

const BIZ = 'EMAIL_LOGIN';

const { FormItem } = Form;

const AccountLogin = forwardRef((props = {}, ref) => {
  const theme = useTheme();
  const withLeft = !!props.forgetLeft;
  const tabKey = props?.tabKey;
  const {
    t,
    i18n: { language },
  } = useLang();
  const isCn = language === 'zh_CN';

  const dispatch = useDispatch();
  const { countryCodes, loginLoading } = useSelector((state) => state[NAMESPACE]);

  useEffect(() => {
    // 登录
    ga('eleExposureCollectionV1', {
      str1: 'KucoinWeb',
      str2: 'KucoinWeb.login',
      str3: 'KucoinWeb.login.Cbutton',
      str4: 'KucoinWeb.login.Cbutton.1',
    });
    // 忘记密码
    ga('eleExposureCollectionV1', {
      str1: 'KucoinWeb',
      str2: 'KucoinWeb.login',
      str3: 'KucoinWeb.login.forgetS',
      str4: 'KucoinWeb.login.forgetS.1',
    });
    dispatch({
      type: `${NAMESPACE}/getCountryCodes`,
    });
  }, []);
  // 坑位曝光事件集合
  const eleExposureGaPhone = () => {
    // 国家
    ga('eleExposureCollectionV1', {
      str1: 'KucoinWeb',
      str2: 'KucoinWeb.login',
      str3: 'KucoinWeb.login.InformationInser',
      str4: 'KucoinWeb.login.InformationInser.1',
    });
    // 手机号
    ga('eleExposureCollectionV1', {
      str1: 'KucoinWeb',
      str2: 'KucoinWeb.login',
      str3: 'KucoinWeb.login.InformationInser',
      str4: 'KucoinWeb.login.InformationInser.2',
    });
    // 密码
    ga('eleExposureCollectionV1', {
      str1: 'KucoinWeb',
      str2: 'KucoinWeb.login',
      str3: 'KucoinWeb.login.InformationInser',
      str4: 'KucoinWeb.login.InformationInser.4',
    });
  };
  // 坑位曝光事件集合
  const eleExposureGaEmail = () => {
    // 邮箱
    ga('eleExposureCollectionV1', {
      str1: 'KucoinWeb',
      str2: 'KucoinWeb.login',
      str3: 'KucoinWeb.login.InformationInser',
      str4: 'KucoinWeb.login.InformationInser.3',
    });
    // 密码
    ga('eleExposureCollectionV1', {
      str1: 'KucoinWeb',
      str2: 'KucoinWeb.login',
      str3: 'KucoinWeb.login.InformationInser',
      str4: 'KucoinWeb.login.InformationInser.4',
    });
  };

  const { onForgetPwdClick = _.noop, phoneLogin = false, trackingConfig } = props;

  const [form] = Form.useForm();

  useEffect(() => {
    if (phoneLogin) {
      eleExposureGaPhone();
    } else {
      eleExposureGaEmail();
    }
    // 登录按钮曝光
    if (trackingConfig && trackingConfig.kc_pageid && trackingConfig.spm) {
      kcsensorsManualTrack(trackingConfig);
    }
  }, [phoneLogin]);
  const _initVal = useMemo(() => {
    return localStorage.getItem(ACCOUNT_KEY.mobileCode) || '';
  }, []);

  let startAdornment = null;
  if (phoneLogin) {
    const areaSelectorOnChange = () => {
      console.log('areaSelectorOnChangeareaSelectorOnChange');
      // 选国家区号
      ga('eleClickCollectionV1', {
        str1: 'KucoinWeb',
        str2: 'KucoinWeb.login',
        str3: 'KucoinWeb.login.InformationInser',
        str4: 'KucoinWeb.login.InformationInser.1',
      });
    };
    startAdornment = (
      <FormItem noStyle name="mobileCode" initialValue={_initVal}>
        <PhoneAreaSelector
          countries={countryCodes}
          isCn={isCn}
          language={language}
          useInit={!!_initVal}
          checkForbidden
          onChange={areaSelectorOnChange}
        />
      </FormItem>
    );
  }
  const handleFocus = (type) => {
    ga('eleClickCollectionV1', {
      str1: 'KucoinWeb',
      str2: 'KucoinWeb.login',
      str3: 'KucoinWeb.login.InformationInser',
      str4: `KucoinWeb.login.InformationInser.${type}`,
    });
  };
  const handleSubmit = (values) => {
    const { onSuccess } = props;
    // 登录
    ga('eleClickCollectionV1', {
      str1: 'KucoinWeb',
      str2: 'KucoinWeb.login',
      str3: 'KucoinWeb.login.Cbutton',
      str4: `KucoinWeb.login.Cbutton.1`,
    });
    // 登录按钮点击
    if (trackingConfig && trackingConfig.kc_pageid && trackingConfig.spm) {
      kcsensorsManualTrack(trackingConfig, 'page_click');
    }
    const payload = { ...values };
    payload.account = payload.account.trim();
    payload.loginType = ACCOUNTLOGINTABKEY;
    if (phoneLogin) {
      payload.phone = payload.account;
      payload.account = `${payload.mobileCode}-${payload.account}`;
      payload.loginType = PHONELOGINTABKEY;
    }
    const source = getTrackingSource(trackingConfig);
    dispatch({
      type: `${NAMESPACE}/login`,
      payload,
      bizType: BIZ,
      onSuccess,
      trackResultParams: {
        source,
      },
    });
  };

  // const debouncedValidateAccount = useCallback(
  //   _.debounce((value) => {
  //     // 校验账户在数据库中是否重复，如果重复了提供区号选择控件
  //     if (value) {
  //       dispatch({
  //         type: `${namespace}/validateAccount`,
  //         payload: {
  //           account: value.trim(),
  //         },
  //       });
  //     }
  //   }, 500),
  //   [dispatch],
  // );

  // const handleValidateAccount = (e) => {
  //   e.persist();
  //   debouncedValidateAccount(e.target.value);
  // };

  const commonRule = [{ required: true, message: t('form.required') }];

  const closeHumanCaptcha = () => {
    dispatch({
      type: `${NAMESPACE}/update`,
      payload: {
        loginLoading: false,
      },
    });
  };

  const _cacheKey = ACCOUNT_KEY[tabKey];

  useFormValidateByLang(form, language);

  useEffect(() => {
    form.resetFields();
  }, [tabKey]);

  return (
    <Form form={form} onFinish={handleSubmit} ref={ref}>
      <HumanCaptcha bizType={BIZ} namespace={NAMESPACE} onClose={closeHumanCaptcha} />
      <FormItem
        requiredMark={false}
        label={phoneLogin ? t('login.group2') : t('login.group1')}
        name="account"
        initialValue={localStorage.getItem(_cacheKey) || ''}
        rules={
          phoneLogin
            ? [
                ...commonRule,
                {
                  pattern: REGEXP.phone,
                  message: t('form.phone.error'),
                },
              ]
            : commonRule
        }
      >
        <Input
          autoFocus
          size="large"
          autoComplete="off"
          addonBefore={startAdornment}
          onFocus={() => handleFocus(phoneLogin ? '1' : '2')}
          // onChange={handleValidateAccount}
        />
      </FormItem>
      <FormItem requiredMark={false} label={t('login.password')} name="password" rules={commonRule}>
        <Input
          autoComplete="new-password"
          type="password"
          size="large"
          onFocus={() => handleFocus('4')}
        />
      </FormItem>
      <Button
        mt={35}
        fullWidth
        htmlType="submit"
        size="large"
        // onClick={handleSubmit}
        loading={loginLoading}
        disabled={loginLoading}
      >
        {loginLoading ? t('login.ing') : t('login')}
      </Button>
      <Box
        style={{
          fontSize: 12,
          lineHeight: '20px',
          color: theme.colors.text60,
          marginTop: 8,
          display: 'flex',
          justifyContent: withLeft ? 'space-between' : 'flex-end',
        }}
      >
        {props.forgetLeft}
        <Box display="inline-block" style={{ cursor: 'pointer' }} onClick={onForgetPwdClick}>
          {t('forget.pwd')}
        </Box>
      </Box>
    </Form>
  );
});

export default AccountLogin;
